<template>
  <v-row dense>
    <v-col cols="12" sm="4">
    <span class="caption font-weight-bold">Armazém</span>
    <div>
      {{ formData.ARMAZEM | truncate(45) }}
    </div>
    </v-col>
    <v-col cols="12" sm="4">
      <span class="caption font-weight-bold">Conta contábil</span>
      <div>
        {{ formData.CONTA_CONTABIL | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
